import { render, staticRenderFns } from "./NormalSearchNav194.vue?vue&type=template&id=522923f6&scoped=true&"
import script from "./NormalSearchNav194.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav194.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522923f6",
  null
  
)

export default component.exports